import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TEST_COMPLETE, TEST_QUESTIONS } from "../../util/constants";
import { getNoCacheCall, postCall } from "../../util/resources";
import SesHeader from "../header";
import {
    CommonLoader,
    CommonPopup,
    CommonQuesProgress,
    SessionExpireCommonPopup,
    useTimer,
    useTimerValues,
} from "../../util/common";
import { BaseContext } from "../../App";
import WarmupComplete from "../instructions/warmupComplete";

const TypingTests = () => {
    const [test, setTest] = useState();
    const [typedAns, setTypedAns] = useState("");
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const [sessionStatus, setSessionStatus] = useState(false);
    const { min, sec, totalSecLeft, setTimer, startTimer, stopTimer } =
        useTimer();
    const { isWarmupDoneShown, setWarmupDoneShown } = useContext(BaseContext);
    const location = useLocation();
    const { timerOverallAssessment } = useTimerValues();
    const phrases = location.state.user.siteConfig.phrases;
    const navigate = useNavigate();
    const formRef = useRef();
    const exampleTest = useRef();
    const quesNo = useRef(-1);
    const timerStarted = useRef(false);
    const header = useRef({
        "x-xpert-session": location.state.user.sessionId,
        "Content-Type": "application/json",
    });

    const handleTypedAns = (e) => {
        if (!timerStarted.current) {
            startTimer();
            timerStarted.current = true;
        }
        setTypedAns(e.target.value);
    };

    const nextNavigate = async (expire) => {
        if (location.state.warmUp) {
            if (test.lastPage) {
                stopTimer();
                if(location.state.previewData){
                    navigate("/instructions", {
                        state: {...location.state},
                    });
                }else{
                    setWarmupDoneShown(true);
                }
            } else {
                getQuestion();
            }
        } else if (location.state.previewData) {
            if (test.lastPage || expire === "sessionEnded") {
                navigate("/");
            } else {
                setTypedAns("");
                formRef.current.reset();
                getQuestion();
            }
        } else {
            const elapsedTime = stopTimer();
            const ansObj = { answers: [], structure: null, value: typedAns };
            let quesObj = test.questions;
            quesObj[0].userAnswer = ansObj;
            const otherData = {
                duration: elapsedTime,
            };
            try {
                let response;
                if (test.lastPage || expire === "sessionEnded") {
                    stopTimer();
                    response = await postCall(
                        TEST_COMPLETE + location.state.test.id,
                        { ...otherData, questions: quesObj },
                        header.current
                    );
                } else {
                    response = await postCall(
                        TEST_QUESTIONS + location.state.test.id,
                        { ...otherData, questions: quesObj },
                        header.current
                    );
                }
                if (response.data.status === true) {
                    if (test.lastPage || expire === "sessionEnded") {
                        navigate("/");
                    } else {
                        setTypedAns("");
                        formRef.current.reset();
                        quesNo.current += 1;
                        getQuestion();
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const getQuestion = async () => {
        if (location.state.warmUp) {
            setTest(exampleTest.current[quesNo.current]);
            setTimer(location.state.test.timeLimitExample);
            quesNo.current += 1;
        } else if (location.state.previewData) {
            setTest(location.state.previewData[quesNo.current]);
            setTimer(location.state.test.timeLimit);
            quesNo.current += 1;
        } else {
            try {
                const response = await getNoCacheCall(
                    TEST_QUESTIONS +
                        location.state.test.id +
                        "/" +
                        quesNo.current,
                    header.current
                );
                setTest(response.data[0]);
                setTimer(location.state.test.timeLimit);
            } catch (error) {
                console.log();
            }
        }
    };

    const formatQuesText = (input) => {
        var returnValue = input.replace(/\r\n/gi, "<br />");
        return returnValue;
    };

    const exitTest = () => {
        if (location.state.previewData) {
            window.close();
        } else
            setpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: location.state.test.name,
                    popupBody: phrases?.["1002189"],
                    popupFooter: phrases?.["14392"],
                };
                return prev;
            });
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
        stopTimer();
        navigate("/");
    };

    const approveAction = async () => {
        const elapsedTime = stopTimer();
        const ansObj = { answers: [], structure: null, value: typedAns };
        let quesObj = test.questions;
        quesObj[0].userAnswer = ansObj;
        const otherData = {
            duration: elapsedTime,
        };
        const response = await postCall(
            TEST_COMPLETE + location.state.test.id,
            { ...otherData, questions: quesObj },
            header.current
        );
        navigate("/");
    };

    useEffect(() => {
        if (totalSecLeft === 0) {
            if (location.state.warmUp) {
                navigate("/instructions", {
                    state: { ...location.state, warmUp: false },
                });
            } else setSessionStatus(true);
        }
    }, [totalSecLeft]);

    useEffect(() => {
        if (location.state.warmUp) {
            exampleTest.current = location.state.test.testExample;
            quesNo.current = 0;
        }
        if (location.state.previewData) {
            quesNo.current = 0;
        }
        getQuestion();
    }, []);

    useEffect(() => {
        if (sessionStatus) {
            setTimeout(() => {
                setSessionStatus(false);
                nextNavigate("sessionEnded");
            }, 5000);
        }
    }, [sessionStatus]);

    const sessionApproveAction = async () => {
        setSessionStatus(false);
        nextNavigate("sessionEnded");
    };

    const backtoInst = () => {
        navigate("/instructions", {
            state: { ...location.state, warmUp: false },
        });
    };

    const handleMainTestStart = () => {
        navigate("/instructions", {
            state: { ...location.state, startMainTest: true },
        });
    };

    if (!test) {
        return <CommonLoader />;
    }

    if (isWarmupDoneShown) {
        return (
            <WarmupComplete
                backtoInst={backtoInst}
                handleMainTestStart={handleMainTestStart}
            />
        );
    }

    return (
        <>
            <div className="g-container flex_col p4 g5 pt0_mobile g2_mobile full-width">
                <SesHeader clientCobranding={location.state.cobrandingLink} />
                <SessionExpireCommonPopup
                    sessionStatus={sessionStatus}
                    sessionApproveAction={sessionApproveAction}
                />
                <CommonQuesProgress test={test} />
                <div className="flex_col g2">
                    <h3>
                        {location.state.warmUp
                            ? location.state.test.testExampleName
                            : location.state.test.name}
                    </h3>
                    <div
                        className="base"
                        dangerouslySetInnerHTML={{
                            __html: test.questions[0].topicInstruction,
                        }}
                    />
                </div>
                <form ref={formRef} className="flex_row flex_col_mobile g2">
                    <div className="flex_col flex_gsb g2">
                        <div className="small-title">
                            {phrases?.["1000204"]}
                        </div>
                        <div className="base p2 roundness_1 border_tt82 full-height">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: formatQuesText(
                                        test.questions[0].questionText
                                    ),
                                }}
                            />
                        </div>
                    </div>
                    <div className="flex_col flex_gsb g2">
                        <div className="flex_row justify-content_between">
                            <label className="small-title" htmlFor="typerAnsTT">
                                {phrases?.["1000203"]}
                            </label>
                            <div
                                className={`tag-ds ${
                                    timerOverallAssessment > 0 &&
                                    timerOverallAssessment < totalSecLeft
                                        ? "status-tag_info"
                                        : "status-tag_error"
                                }`}
                            >
                                <span className="material-icons-outlined icon-order">
                                    timer
                                </span>
                                {min}:{sec}
                            </div>
                        </div>
                        <textarea
                            className="base p2 roundness_1 border_tt82 full-height"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            onChange={handleTypedAns}
                            value={typedAns}
                            id="typerAnsTT"
                        />
                    </div>
                </form>
                <hr />
                <div className="flex_col_reverse_mobile flex_row align-items_center justify-content_between g2">
                    {test.lastPage ? (
                        <div />
                    ) : (
                        <button
                            className="button-secondary text_uppercase full-width_mobile"
                            onClick={exitTest}
                        >
                            {phrases?.["1002190"]}
                        </button>
                    )}
                    <button
                        className="button-primary text_uppercase full-width_mobile"
                        disabled={typedAns.length === 0}
                        onClick={nextNavigate}
                    >
                        {test.lastPage
                            ? location.state.warmUp
                                ? phrases?.["1000252"]
                                : phrases?.["15140"]
                            : phrases?.["10976"]}
                    </button>
                </div>
            </div>
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                approveAction={approveAction}
                setterFun={setpopupData}
            />
        </>
    );
};

export default TypingTests;
